import {
  EE_BUILDING_SESSION_FAILURE,
  EE_BUILDING_SESSION_FINISHED,
  EE_BUILDING_SESSION_SUCCEEDED,
} from '../actionConstants';

const defaultState = {
  sessionIds: {},
  sessionIdError: {},
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case EE_BUILDING_SESSION_SUCCEEDED:
      return {
        ...state,
        sessionIds: {
          ...state.sessionIds,
          [action.buildingId]: action.payload.data,
        },
      };
    case EE_BUILDING_SESSION_FAILURE:
      return {
        ...state,
        sessionIdError: {
          ...state.sessionIdError,
          [action.buildingId]: action.payload,
        },
      };
    case EE_BUILDING_SESSION_FINISHED:
      return defaultState;
    default:
      return state;
  }
};
